module.exports = __webpack_public_path__ + "img/en_tis_uninstall2.0824715a.png";